import React from "react";
import "./A2Benefits.css";
const A2BenefitsMain = () => {
  return (
    <div className="LvlBenefitsMainContainer">
      <ul>
        <li>
          <span>Elementary Level Proficiency :</span> This course serves as the
          upper beginner level, providing foundational skills in German.
        </li>
        <li>
          <span>Duration :</span> The course spans approximately 45-50 hours,
          ensuring a comprehensive learning experience.
        </li>
        <li>
          <span>Understanding Sentences and Expressions :</span> You will grasp
          commonly used sentences and expressions, facilitating basic
          communication.
        </li>
        <li>
          <span> Core Grammar and Structure :</span> Gain a solid understanding
          of fundamental grammar and sentence structure, crucial for advancing
          your German proficiency.
        </li>
        <li>
          <span>Theme-Based Learning :</span> Focuses on common topics,
          enhancing your ability to communicate effectively in routine
          situations.
        </li>
      </ul>
    </div>
  );
};

export default A2BenefitsMain;
